<div class="container mt-lg-4 mt-4">
  <h4 class="mb-3">Projekt Übersicht</h4>
  <div class="row">
    <div class="col-lg-4 mt-4" linkTileComponent [routerLink]="'/home/ibkprojects'" [linkText]="'IBK Projekte'" [iconCSS]="'fa fa-database'"></div>
    <div class="col-lg-4 mt-4" linkTileComponent [routerLink]="'/home/kpprojects'" [linkText]="'Kleinprojekte'" [iconCSS]="'fa fa-database'"></div>

  </div>
</div>
